import type { AppState } from "store/types";

export const getApplicationSidebarKey = (_state: AppState) => undefined;

export const getWorkflowSidebarKey = (_state: AppState) => undefined;
